
export function format_num(num){
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "  ");
}
